module.exports = __webpack_public_path__ + "static/camobackground-be61ebb4c037ae80180b7512837fbb52.png";